import { FC } from "react"

export type InputRadioGroupProps = {
  /**
   * Component id
   */
  id: string
  /**
   * Text to be used as label and placeholder
   */
  label: string
  options: Array<string>
  value: string
  handleChange: (value: string) => void
  isMobile?: boolean
}

export const InputRadioGroup: FC<InputRadioGroupProps> = ({
  id,
  label,
  options,
  value,
  handleChange,
  isMobile = true,
}) => {
  const renderRadio = (selected: boolean) => {
    return (
      <>
        {selected ? (
          <div className="mt-0.5 h-4 w-4 bg-brand-light rounded-full">
            <div className="mt-1 ml-1 h-2 w-2 bg-white rounded-full" />
          </div>
        ) : (
          <div className="mt-0.5 h-4 w-4 border border-gray-300 rounded-full" />
        )}
      </>
    )
  }

  return (
    <div className="mb-4 w-full">
      <label
        htmlFor={id}
        className="block text-sm px-3 font-medium text-semibold text-gray-700"
      >
        {label}
      </label>
      <div className="flex space-x-2 mt-2">
        {options.map((option: string) => {
          return (
            <div
              key={option}
              className={`flex items-center justify-between px-4 w-1/2 rounded h-10 text-sm cursor-pointer ${
                isMobile ? "bg-white" : "bg-form-medium"
              }`}
              onClick={() => handleChange(option)}
            >
              {option}
              {renderRadio(String(value) === String(option))}
            </div>
          )
        })}
      </div>
    </div>
  )
}
